
import 'slick-carousel';


;(function($) {

    $(document).ready(function() {
        $(".banner .wp-block-group.background_contents").slick({
            slidesToShow: 1,
            infinite: true,
            autoplay: true,
            autoplaySpeed: 4000,
            speed: 1000,
            arrows: false,
            fade: true
        });
     
    });
}(jQuery));